import { flow, head, join, map, slice, toUpper, words } from 'lodash/fp';

const getInitials = flow(
  words,
  slice(0, 2),
  map(flow(head, toUpper)),
  join(''),
);

export default getInitials;
